export enum InvoiceImpuestoIvaTraslado {
  'Impuesto 0' = 0,
  'Impuesto Excento' = null,
  'Impuesto 16%' = 0.16,
}
